import { forwardRef, FunctionComponent } from 'react'
import {
  Tab as ReactTab,
  Tabs as ReactTabs,
  TabList as ReactTabList,
  TabPanel as ReactTabPanel,
  TabProps,
  TabsProps,
  TabListProps,
  TabPanelProps
} from 'react-tabs'
import { Box, BoxProps } from 'theme-ui'

import { pageTabs } from 'src/theme/adSales/pageTabs'

export const PageTab: FunctionComponent<TabProps> = ReactTab
export const PageTabList: FunctionComponent<TabListProps> = ReactTabList
export const PageTabPanel: FunctionComponent<TabPanelProps> = ReactTabPanel

type PageTabVariants = `pageTabs.${keyof typeof pageTabs}`

export interface PageTabProps extends Omit<BoxProps, 'variant'> {
  variant: PageTabVariants
}

type PageTabsProps = PageTabProps & Omit<TabsProps, 'ref'>

export const PageTabs = forwardRef<any, PageTabsProps>(function Tabs(
  { selectedIndex, ...props },
  ref
) {
  return (
    <Box {...props} ref={ref}>
      <ReactTabs selectedIndex={selectedIndex} {...props} />
    </Box>
  )
})
